import React, { Component } from "react";

import { IRtcStream } from "@formant/core/model/IRtcStream";

import { ITeleopSession } from "../../../teleop/ITeleopSession";

export interface ITeleopImageData {
    streamName?: string;
    value?: string;
    time?: Date;
}

export interface ITeleopStatusData {
    [k: string]: boolean;
}

export interface ITeleopModuleProps {
    session: ITeleopSession;
    enabled?: boolean;
    streams?: IRtcStream[];
    className?: string;
    children?: React.ReactNode;
}

export class TeleopModule extends Component<ITeleopModuleProps> {
    public render() {
        const { children, className } = this.props;
        return <div className={className}>{children}</div>;
    }
}
